import { Icon, stopPropagation } from '@app/ui';
import { Button, Input, Tooltip } from 'antd';
import isHotkey from 'is-hotkey';
import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { EncounterTemplateInputType } from './AddEncounterTemplateTreeNode';
import { useTranslation } from 'react-i18next';

const isEsc = isHotkey('escape');
const isEnter = isHotkey('enter');

export interface EncounterTemplateInputNodeProps {
  initialValue?: string;
  onSubmit: (value: string) => void;
  onCancel: () => void;
  tooltip?: React.ReactNode;
  type: EncounterTemplateInputType;
}

export function EncounterTemplateInputNode(props: EncounterTemplateInputNodeProps) {
  const { initialValue, onSubmit, onCancel, tooltip, type } = props;
  const [value, setValue] = useState(initialValue);
  const { t } = useTranslation();
  useEffect(() => setValue(initialValue), [initialValue]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isEmpty(value)) onSubmit(value!);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (isEsc(e)) {
      onCancel();
    } else if (isEnter(e)) {
      handleSubmit(e);
    }
  };

  return (
    <Tooltip defaultOpen={true} title={tooltip}>
      <Input
        placeholder={t(
          type === 'FOLDER'
            ? 'encounterTemplates.nav.folders.inputPlaceHolder'
            : 'encounterTemplates.nav.templates.inputPlaceHolder',
        )}
        value={value ?? ''}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        variant="borderless"
        size="small"
        className="h-6"
        max={250}
        autoFocus
        onClick={stopPropagation}
        suffix={
          <span className="space-x-2">
            <Button onClick={handleSubmit} icon={<Icon type="check" />} aria-label={t('save')} />
            <Button onClick={onCancel} icon={<Icon type="close" />} aria-label={t('cancel')} />
          </span>
        }
      />
    </Tooltip>
  );
}
